/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 抽奖附属信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  id: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.LuckDrawAuxiliaryDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/activity-Info/auxiliary/${id}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
